import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useFetch } from "@/hooks/useFetch";
import { fmtDateTime } from "@/lib/format";
import { Card, Empty, PageHeader, Sel } from "@/components/Field";

const TYPES = ["product", "movement", "shopping_item", "task", "event", "room", "booking", "membership", "invitation", "association", "report"].map((v) => ({ value: v, label: v }));

export default function AuditPage() {
  const [page, setPage] = useState(1);
  const [type, setType] = useState("");
  const { data } = useFetch(`/audit?page=${page}&page_size=50${type ? `&object_type=${type}` : ""}`);
  const pages = data ? Math.max(1, Math.ceil(data.total / 50)) : 1;
  return (
    <>
      <PageHeader title="Registro attività" subtitle="Storico delle operazioni rilevanti. Non modificabile." />
      <div className="max-w-xs"><Sel testId="audit-filter-type" value={type} onChange={(v) => { setType(v); setPage(1); }} placeholder="Tutti gli oggetti" options={TYPES} /></div>
      {data && data.items.length === 0 ? <Empty text="Nessuna operazione registrata." /> : (
        <Card className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="audit-table">
            <thead className="bg-slate-50 text-left text-slate-600"><tr>{["Data e ora", "Utente", "Operazione", "Oggetto", "Dettagli"].map((h) => <th key={h} className="px-4 py-2 font-semibold">{h}</th>)}</tr></thead>
            <tbody className="divide-y">
              {data?.items.map((a) => (
                <tr key={a.id}><td className="px-4 py-2 whitespace-nowrap">{fmtDateTime(a.created_at)}</td><td className="px-4 py-2">{a.user_name}</td><td className="px-4 py-2 font-medium">{a.action}</td>
                  <td className="px-4 py-2">{a.object_type}</td><td className="px-4 py-2 text-slate-500 max-w-md truncate">{Object.keys(a.details || {}).length ? JSON.stringify(a.details) : ""}</td></tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
      {pages > 1 && (
        <div className="flex items-center justify-center gap-3">
          <Button variant="outline" className="h-11" disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid="audit-prev"><ChevronLeft className="h-4 w-4" /></Button>
          <span className="text-sm">Pagina {page} di {pages}</span>
          <Button variant="outline" className="h-11" disabled={page >= pages} onClick={() => setPage(page + 1)} data-testid="audit-next"><ChevronRight className="h-4 w-4" /></Button>
        </div>
      )}
    </>
  );
}
